import React, { useContext } from 'react';
import UserContext from '../../context/UserContext';
import styles from './MensajeError.module.css';

const MensajeError = (props) => {
  const estiloAdicional = props.estilo;
  const errores = props.errores;
  const { suppressErrors } = useContext(UserContext);
  // Also suppress when there is no usuario and backend is down (session-expired flow)
  const { usuario, estadoBackend } = useContext(UserContext);
  if (suppressErrors || (usuario === null && estadoBackend === false)) return null;

  // Normaliza diferentes formas de "errores" a un array de strings
  const normalizarErrores = (e) => {
    if (!e) return [];
    if (Array.isArray(e)) return e;
    if (typeof e === 'string') return [e];
    if (e instanceof Error) return [e.message];
    if (typeof e === 'object') {
      // Formato común del backend: { errores: ["..."] }
      if (Array.isArray(e.errores)) return e.errores;
      if (typeof e.error === 'string') return [e.error];
      if (Array.isArray(e.error)) return e.error;
      if (typeof e.message === 'string') return [e.message];
      // Intenta recolectar strings dentro del objeto
      const values = Object.values(e);
      const strings = values.flatMap((v) =>
        Array.isArray(v) ? v.filter((x) => typeof x === 'string') : typeof v === 'string' ? [v] : []
      );
      return strings.length > 0 ? strings : [JSON.stringify(e)];
    }
    return [String(e)];
  };

  const listaErrores = normalizarErrores(errores);

  if (listaErrores.length > 0) {
    console.log('MensajeError - Errores:', listaErrores);
  }

  return (
    <React.Fragment>
      {listaErrores.length > 0 && (
        <div className={`${styles.errorContainer}`}>
          {listaErrores.map((error, index) => (
            <div key={index} className={`${styles.errores} ${estiloAdicional}`}>
              {error}
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default MensajeError;
